import { toTestType } from '@risksmart-app/domain/src/types/consts/test-type';
import type { useGetTestResultById } from 'src/hooks/queries/test-result/useGetTestResultById';

import type { TestResultFormFieldsData } from './testResultSchema';

type GetTestResultByIdData = NonNullable<
  ReturnType<typeof useGetTestResultById>['data']
>;

type SourceTestResult = GetTestResultByIdData['test_result'][number];

/**
 * Smart Copy (WOR-2): builds form default values from a source test result so
 * the modal opens pre-populated. The four outcome fields (Design Effectiveness,
 * Performance Effectiveness, Overall Effectiveness, Test Date) plus file
 * attachments are excluded so the user always enters fresh values for them.
 * Id and audit fields are stripped so the save path takes the create branch —
 * the new record is independent of the source.
 */
export const buildCopiedTestResultDefaults = (
  source: SourceTestResult,
  parentControlId: string
): Partial<TestResultFormFieldsData> => ({
  Title: source.Title ?? null,
  TestType: source.TestType ? toTestType(source.TestType) : undefined,
  Description: source.Description ?? '',
  ParentControlIds: [{ value: parentControlId }],
  Submitter: { value: source.Submitter, type: 'user' },
  CustomAttributeData: source.CustomAttributeData ?? null,
});
